import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "rpp-create" }
const _hoisted_2 = { class: "mt-6" }
const _hoisted_3 = { class: "flex items-center justify-between mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_rpp_form = _resolveComponent("rpp-form")!
  const _component_rpp_filters = _resolveComponent("rpp-filters")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_rpp_orders_list_item = _resolveComponent("rpp-orders-list-item")!
  const _component_list = _resolveComponent("list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.form_state.is_visible)
      ? (_openBlock(), _createBlock(_component_rpp_form, {
          key: 0,
          onCreate: _ctx.createRPP,
          onCancel: _ctx.toggleRPPForm
        }, null, 8, ["onCreate", "onCancel"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_rpp_filters, {
            loading: _ctx.data_state.rpp_orders.is_loading,
            onSearch: _ctx.onSearch
          }, null, 8, ["loading", "onSearch"]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_page_title, { title: "Список заказов" })
            ]),
            (
                        _ctx.data_state.rpp_orders.is_failed &&
                        !_ctx.data_state.rpp_orders.failure.error_state.is_cancel
                    )
              ? (_openBlock(), _createBlock(_component_failed_fetch, {
                  key: 0,
                  loading: _ctx.data_state.rpp_orders.is_loading,
                  text: "При получении списка договоров произошла ошибка",
                  "error-message": _ctx.data_state.rpp_orders.failure.error_state.message,
                  "error-url": _ctx.data_state.rpp_orders.failure.error_state.url,
                  "error-status": _ctx.data_state.rpp_orders.failure.error_state.status,
                  onRefresh: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadRPPOrdersList(_ctx.data_state.rpp_orders.pagination.current_page)))
                }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
              : (_openBlock(), _createBlock(_component_list, {
                  key: 1,
                  loading: _ctx.data_state.rpp_orders.is_loading,
                  items: _ctx.data_state.rpp_orders.list,
                  pagination: "",
                  "pagination-current-page": _ctx.data_state.rpp_orders.pagination.current_page,
                  "pagination-total-pages": _ctx.data_state.rpp_orders.pagination.total_pages,
                  onChangePage: _ctx.loadRPPOrdersList
                }, {
                  item: _withCtx(({ item }) => [
                    _createVNode(_component_rpp_orders_list_item, {
                      item: item,
                      onSelect: _ctx.onOrderSelected
                    }, null, 8, ["item", "onSelect"])
                  ]),
                  _: 1
                }, 8, ["loading", "items", "pagination-current-page", "pagination-total-pages", "onChangePage"]))
          ])
        ], 64))
  ]))
}